import { useEffect, useRef, useState } from "react";

function PatientMilestones() {
    const [count, setCount] = useState(0);
    const sectionRef = useRef(null);
    const hasAnimated = useRef(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !hasAnimated.current) {
                    hasAnimated.current = true;

                    let start = 0;
                    const end = 50000;
                    const duration = 2000;
                    const step = Math.ceil(end / (duration / 20));

                    const counter = setInterval(() => {
                        start += step;
                        if (start >= end) {
                            setCount(end);
                            clearInterval(counter);
                        } else {
                            setCount(start);
                        }
                    }, 20);
                }
            },
            { threshold: 0.4 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => observer.disconnect();
    }, []);

    const gradientBg =
        "linear-gradient(135deg, #0b3c78, #1e6fd9, #7cc7f5, #e7b7f3)";

    return (
        <section
            ref={sectionRef}
            className="relative px-4 md:px-10 py-16"
            style={{ background: gradientBg }}
        >
            <div className="max-w-6xl mx-auto">

                {/* 🔵 OUTER GRADIENT BOX */}
                <div
                    className="relative rounded-3xl shadow-2xl overflow-hidden p-6 md:p-10"
                    style={{ background: gradientBg }}
                >
                    <div className="grid md:grid-cols-2 gap-10 items-center">

                        {/* LEFT CONTENT */}
                        <div>
                            <h3 className="text-3xl font-extrabold text-white mb-6">
                                Patient Success Milestones
                            </h3>

                            <ul className="space-y-4 text-white/95 text-lg">
                                {[
                                    "20,000+ successful OPD consultations",
                                    "Thousands of patients recovered successfully",
                                    "High patient satisfaction & recovery rate",
                                    "24×7 emergency & critical care support",
                                ].map((text, i) => (
                                    <li key={i} className="flex items-center gap-3">
                                        <span className="w-8 h-8 flex items-center justify-center rounded-full bg-white/20 text-white font-bold">
                                            ✓
                                        </span>
                                        {text}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* RIGHT COUNTER */}
                        <div className="relative">
                            <div
                                className="rounded-2xl p-10 shadow-2xl text-center"
                                style={{ background: gradientBg }}
                            >
                                <p className="text-5xl font-extrabold text-white">
                                    {count.toLocaleString()}+
                                </p>
                                <p className="mt-2 text-white/90 font-medium">
                                    Lives Changed Successfully
                                </p>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </section>
    );
}

export default PatientMilestones;
